<div class="modal-content">
  <div class="modal-header">
    Edit Image
    <i
      class="material-icons"
      data-bs-dismiss="modal"
      (click)="closeEditImageModal()"
      >close</i
      >
    </div>
    @if (imgBlock) {
      <div class="modal-body" style="padding: 35px">
        <form [formGroup]="uploadImageForm">
          <div class="row mb-2">
            <div class="col-12">
              <div class="upload-assets">
                <div (click)="openFileDialog()" class="upload-assets-file">
                  @if (!imgBlock.assetId) {
                    <div
                      class="upload-box pointer"
                      title="click to change file"
                      >
                      <span class="material-icons upload-icon upload-icon-color"
                        >cloud_upload</span
                        >
                      </div>
                    } @else {
                      <img
                        id="imgBackground"
                        title="click to change file"
                        [ngStyle]="{ width: imgBlock.assetId ? 'auto' : '100%' }"
                        class="upload-box pointer"
                        [src]="getImageSrc() | loadSecureAssets : true | async"
                        alt=""
                        style="object-fit: contain"
                        onerror="this.src = 'assets/img/loader.gif'"
                        (load)="imageLoaded = true"
                        [hidden]="!imageLoaded"
                        />
                    }
                    <div class="file-upload hide">
                      <input
                        id="uploadImage"
                        #fileInput
                        (click)="fileInput.value = null"
                        (change)="fileSelected($event)"
                        accept="image/jpg, image/jpeg, image/png, image/gif"
                        class="file-upload__input"
                        type="file"
                        name="preview-file-upload"
                        />
                    </div>
                  </div>
                  @if (showProgress) {
                    <section
                      class="modal-pop"
                      style="position: relative !important"
                      >
                      <div class="progress progress-striped active">
                        <div
                          class="progress-bar progress-bar-striped progress-bar-animated"
                          role="progressbar"
                          [attr.aria-valuenow]="progressPercent"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          [style.width]="progressPercent + '%'"
                          >
                          {{ progressPercent }}%
                        </div>
                      </div>
                    </section>
                  }
                  <span
                    class="video-file-name align-content-end"
                    title="{{ imgBlock.asset?.name || 'Upload JPEG, PNG or GIF' }}"
                    >
                    {{ imgBlock.asset?.name || "Upload JPEG, PNG or GIF" }}
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-7">
                <label class="custom-checkbox custom__checkmark top-spacer-2">
                  <input
                    id="cbx1021"
                    class="checkbox"
                    type="checkbox"
                    formControlName="enlargeImage"
                    />
                  <span class="checkmark checkbox"></span>
                </label>
                <label for="cbx1021" style="color: grey; font-weight: 700"
                  >Enlarge Image</label
                  >
                </div>
              </div>
              <ul class="nav nav-pills list-tabs top-spacer-20">
                <li class="img-txt-msg me-4">Image Action (on click)</li>
                <li [ngClass]="{ active: selectedPill == 'link' }">
                  <a
                    href="javascript:void(0)"
                    (click)="selectedPill = 'link'"
                    class="type-text"
                    >Link</a
                    >
                  </li>
                  @if (items !== null) {
                    <li
                      [ngClass]="{ active: selectedPill == 'slideshow' }"
                      >
                      <a
                        href="javascript:void(0)"
                        (click)="selectedPill = 'slideshow'; slideshowInit()"
                        class="type-text"
                        >Slideshow</a
                        >
                      </li>
                    }
                    <li [ngClass]="{ active: selectedPill == 'hotspot' }">
                      <a
                        href="javascript:void(0)"
                        (click)="selectedPill = 'hotspot'"
                        class="type-text"
                        >Hotspots</a
                        >
                      </li>
                    </ul>
                    <hr style="margin-top: 0; border-color: #428bca" />
                    @if (selectedPill === 'link') {
                      <div>
                        <div class="form-group">
                          <div class="row align-items-center">
                            <label for="LinkURL" class="col-3 ps-0 Bold control-label"
                              >Link URL</label
                              >
                              <div class="col-sm-8">
                                <input
                                  type="url"
                                  id="ImageLink"
                                  name="ImageLink"
                                  formControlName="linkUrl"
                                  class="col-12 form-control"
                                  />
                                @if (
                                  form.linkUrl.errors &&
                                  (form.linkUrl.dirty ||
                                  form.linkUrl.touched ||
                                  uploadImageForm.value.linkUrl !== '')
                                  ) {
                                  <div
                                    class="text-danger"
                                    >
                                    @if (form.linkUrl.errors.pattern) {
                                      <div>
                                        Please enter valid URL (i.e. https://google.com)
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      @if (selectedPill === 'slideshow') {
                        <div>
                          <div class="row">
                            <div class="col-md-12 form-group">
                              <div class="row align-items-center">
                                <label class="control-label col-sm-4" for="slideshow"
                                  >Slideshow Settings</label
                                  >
                                </div>
                              </div>
                              <div class="col-md-12 form-group">
                                <div class="row align-items-center">
                                  <label for="type" class="control-label col-sm-4" id="groupLabelId"
                                    >Group</label
                                    >
                                    @if (!isGroupEditable) {
                                      <div
                                        class="col-sm-6 inline-label-wrapper"
                                        >
                                        <ng-select
                                          class="custom"
                                          [items]="people3$ | async"
                                          bindLabel="name"
                                          [addTag]="!languageId || languageId == 1"
                                          [multiple]="false"
                                          [hideSelected]="true"
                                          [loading]="people3Loading"
                                          formControlName="agree"
                                          [typeahead]="people3input$"
                                          (change)="another($event)"
                                          [clearable]="true"
                                          >
                                        </ng-select>
                                      </div>
                                    }
                                    @if (isGroupEditable) {
                                      <div
                                        class="col-sm-6 inline-label-wrapper"
                                        >
                                        <div class="input-group">
                                          <ng-container [formGroup]="editImageGroupForm">
                                            <input
                                              class="form-control"
                                              placeholder="Group Name"
                                              formControlName="editImageGroupName"
                                              (keyup.enter)="updateImageGroup()"
                                              />
                                            <span class="input-group-btn">
                                              <button
                                                class="btn btn-default"
                                                type="button"
                                                (click)="cancelGroupUpdate()"
                        style="
                          height: 34px;
                          background: #ececec;
                          border-color: #ccc;
                        "
                                                >
                                                Cancel
                                              </button>
                                            </span>
                                          </ng-container>
                                        </div>
                                      </div>
                                    }
                                    @if (
                                      !isGroupEditable &&
                                      selectedImageGroup != null &&
                                      (!languageId || languageId == 1)
                                      ) {
                                      <div
                                        class="col-sm-2"
                                        >
                                        <i
                                          class="material-icons pointer"
                                          (click)="setEditableGroupName()"
                                          >create</i
                                          >
                                          @if (
                                            selectedImageGroup.name && !selectedImageGroup.isDefault
                                            ) {
                                            <i
                                              class="material-icons pointer"
                                              (click)="deleteImageGroup(selectedImageGroup)"
                                              >delete</i
                                              >
                                            }
                                          </div>
                                        }
                                      </div>
                                    </div>
                                    <div class="form-group">
                                      <div class="row align-items-center">
                                        <div class="offset-sm-4 col-sm-8">
                                          @if (
                                            isGroupEditable &&
                                            submitted &&
                                            editImageGroupFormControl.editImageGroupName.errors
                                            ) {
                                            <div
                                              class="col-md-12 inline-label-wrapper text-danger"
                                              >
                                              @if (
                                                editImageGroupFormControl.editImageGroupName.errors
                                                .required
                                                ) {
                                                <small
                                                  >Image group name is required</small
                                                  >
                                                }
                                                @if (
                                                  editImageGroupFormControl.editImageGroupName.errors
                                                  .maxlength
                                                  ) {
                                                  <small
                                                    >Image group name must be less than 200 characters</small
                                                    >
                                                  }
                                                </div>
                                              }
                                            </div>
                                          </div>
                                        </div>
                                        @if (selectedImageGroup != null) {
                                          <div
                                            class="col-md-12"
                                            style="background-color: #fff"
                                            >
                                            <div class="image-upload-container medium" style="top: 140px">
                                              <input
                                                type="file"
                                                ng2FileSelect
                                                #fileInput
                                                (click)="clearSlideShowImages()"
                                                value=""
                                                [uploader]="uploader"
                                                multiple
                                                class="uploadResource btn"
                                                id="multifile-in"
                                                (change)="onFileChange()"
                                                />
                                              <label class="d-block" for="multifile-in">
                                                <div
                                                  ng2FileDrop
                                                  [ngClass]="{ 'nv-file-over': hasBaseDropZoneOver }"
                                                  class="col-md-12 text-center imageupload well my-drop-zone"
                                                  id="uploadQ"
                                                  [uploader]="uploader"
                                                  (fileOver)="fileOverBase($event)"
                  style="
                    background-color: #fff !important;
                    border-radius: 0px;
                    border: 3px dashed #ccc;
                    overflow-y: auto;
                    overflow-x: hidden;
                    padding: 3px 20px 10px 20px;
                  "
                                                  >
                                                  @if (uploader.queue.length == 0) {
                                                    <p
                                                      class="drop-message-file"
                                                      >
                                                      drop slideshow images here or click to browse
                                                    </p>
                                                  }
                                                  @for (item of uploader.queue; track item) {
                                                    <div class="col-12 p-0">
                                                      @if (item) {
                                                        <div
                                                          class="uploadifive-queue-item progress-bar-style"
                                                          id="uploadifive-uploadCAssets-file-2"
                        [ngClass]="
                          item?.progress == 100
                            ? 'padding-bottom-15'
                            : 'padding-bottom-5'
                        "
                                                          >
                                                          <a
                                                            class="delete-asset"
                                                            href="javascript:void(0)"
                                                            (click)="item.remove()"
                                                            >X</a
                                                            >
                                                            <div>
                                                              <span class="filename"> {{ item?.file?.name }} </span>
                                                              <span class="fileinfo">
                                                                @if (item?.progress != 100) {
                                                                  {{ item?.progress }}%
                                                                }
                                                                @if (item?.progress == 100) {
                                                                  Completed
                                                                }
                                                              </span>
                                                            </div>
                                                            @if (item && item.progress !== 100) {
                                                              <div
                                                                class="progress"
                                                                >
                                                                <div
                                                                  class="progress-bar"
                            [style.width.%]="
                              item?.progress ? item.progress : '0'
                            "
                                                                ></div>
                                                              </div>
                                                            }
                                                          </div>
                                                        }
                                                      </div>
                                                    }
                                                  </div>
                                                </label>
                                              </div>
                                            </div>
                                          }
                                        </div>
                                        @if (imageGroupDetails && imageGroupDetails?.length) {
                                          <div
                                            cdkDropListGroup
                                            class="flexbox-list"
                                            >
                                            <div
                                              cdkDropList
                                              [cdkDropListEnterPredicate]="enter"
                                              (cdkDropListDropped)="drop($event)"
                                              #placeholder
                                            ></div>
                                            @for (imageGroup of imageGroupDetails | orderBy : 'order'; track imageGroup) {
                                              <div
                                                id="clip-{{ imageGroup.id }}"
                                                cdkDropList
                                                [cdkDropListEnterPredicate]="enter"
                                                (cdkDropListDropped)="drop($event)"
                                                >
                                                <div cdkDrag class="created-list Sortable-Tiles">
                                                  <span id="uniqeId">{{ imageGroup.order + 1 }}</span>
                                                  <div class="float-end">
                                                    <a class="delete" (click)="deleteUploadedImage(imageGroup)">
                                                      <i class="material-icons pointer" style="color: #7f7f7f"
                                                        >delete</i
                                                        >
                                                      </a>
                                                      @if (imageGroupDetails.length > 1) {
                                                        <a class="reorder">
                                                          <i class="material-icons pointer" style="color: #7f7f7f"
                                                            >open_with</i
                                                            >
                                                          </a>
                                                        }
                                                      </div>
                                                      <!--  azure issue check -->
                                                      <div class="clipboard-content">
                                                        <img
                                                          class="clipped-image"
                  src="{{
                    '/api/Assets/Image/' + imageGroup?.assetId + '?width=100'
                      | loadSecureAssets : true
                      | async
                  }}"
                                                          alt=""
                                                          style="width: 100px; max-height: 60px"
                                                          (load)="imageGroup.imageLoaded = true"
                  [hidden]="
                    imageGroup.imageLoaded == null ||
                    imageGroup.imageLoaded == false
                  "
                                                          />
                                                        @if (
                                                          imageGroup.imageLoaded == '' ||
                                                          imageGroup.imageLoaded == null ||
                                                          imageGroup.imageLoaded == false
                                                          ) {
                                                          <div
                                                            style="width: 100px; max-height: 60px"
                                                            class="ng-hide"
                                                            >
                                                            <img src="/assets/img/loader.gif" alt="" />
                                                          </div>
                                                        }
                                                      </div>
                                                    </div>
                                                  </div>
                                                }
                                              </div>
                                            }
                                          </div>
                                        }
                                        <!-- Initial changes for hotspot editor -->
                                        @if (selectedPill === 'hotspot') {
                                          <div>
                                            <div id="hotspot" class="tab-pane">
                                              <div class="img-tab-marginb img-tab-margint">
                                                <div class="row">
                                                  <div
                                                    class="col-sm-9 no-horizontal-padding"
                                                    style="display: inline-flex"
                                                    >
                                                    <div class="col-md-5 col-sm-12">
                                                      <label class="hotspot-label-txt control-label"
                                                        >Drag to Add Button</label
                                                        >
                                                      </div>
                                                      <div class="col-md-7 col-sm-12">
                                                        <img
                                                          appHotspotDrag
                                                          id="assets/img/hotspotIcon/bell_only.png"
                                                          [attr.buttonColor]="butonColor"
                                                          type="button"
                                                          class="img-icon"
                    [ngStyle]="{
                      'background-color': butonColor,
                      'border-radius': '100%'
                    }"
                                                          src="../../../../../assets/img/hotspotIcon/bell_only.png"
                                                          />
                                                        <img
                                                          appHotspotDrag
                                                          id="assets/img/hotspotIcon/info_only.png"
                                                          [attr.buttonColor]="butonColor"
                                                          type="button"
                                                          class="img-icon"
                    [ngStyle]="{
                      'background-color': butonColor,
                      'border-radius': '100%'
                    }"
                                                          src="../../../../../assets/img/hotspotIcon/info_only.png"
                                                          />
                                                        <img
                                                          appHotspotDrag
                                                          id="assets/img/hotspotIcon/locator_only.png"
                                                          [attr.buttonColor]="butonColor"
                                                          type="button"
                                                          class="img-icon"
                    [ngStyle]="{
                      'background-color': butonColor,
                      'border-radius': '100%'
                    }"
                                                          src="../../../../../assets/img/hotspotIcon/locator_only.png"
                                                          />
                                                        <img
                                                          appHotspotDrag
                                                          id="assets/img/hotspotIcon/plus_only.png"
                                                          [attr.buttonColor]="butonColor"
                                                          type="button"
                                                          class="img-icon"
                    [ngStyle]="{
                      'background-color': butonColor,
                      'border-radius': '100%'
                    }"
                                                          src="../../../../../assets/img/hotspotIcon/plus_only.png"
                                                          />
                                                        <img
                                                          appHotspotDrag
                                                          id="assets/img/hotspotIcon/star_only.png"
                                                          [attr.buttonColor]="butonColor"
                                                          type="button"
                                                          class="img-icon"
                    [ngStyle]="{
                      'background-color': butonColor,
                      'border-radius': '100%'
                    }"
                                                          src="../../../../../assets/img/hotspotIcon/star_only.png"
                                                          />
                                                      </div>
                                                    </div>
                                                    <div
                                                      class="col-sm-3 no-horizontal-padding"
                                                      style="display: inline-flex"
                                                      >
                                                      <div class="col-md-6 col-sm-12 no-horizontal-padding">
                                                        <label class="hotspot-label-txt control-label text-start"
                                                          >Button Color</label
                                                          >
                                                        </div>
                                                        <div class="col-md-6 col-sm-12 no-left-padding">
                                                          <input
                                                            [(colorPicker)]="butonColor"
                                                            [style.background]="butonColor"
                                                            class="colorinput"
                                                            cpOKButton="true"
                                                            [cpCancelButton]="false"
                                                            cpOKButtonClass="btn vPlaybookDefaultButton btn__btn-default"
                                                            cpCancelButtonClass="btn vPlaybookDefaultButton btn__btn-default mr-10"
                                                            />
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="clear-fix"></div>
                                                    <div class="row top-spacer-20">
                                                      <div class="col-md-10" style="display: inline-flex">
                                                        <div class="col-md-6 col-sm-12 no-horizontal-padding">
                                                          <label class="hotspot-label-txt control-label"
                                                            >Draw Transparent Button Area</label
                                                            >
                                                          </div>
                                                          <img
                                                            appHotspotDrag
                                                            id="assets/img/hotspotIcon/Draw_circle.png"
                                                            type="circle"
                                                            src="../../../../../assets/img/hotspotIcon/Draw_circle.png"
                                                            />
                                                          <img
                                                            appHotspotDrag
                                                            id="assets/img/hotspotIcon/Draw_square.png"
                                                            type="square"
                                                            src="../../../../../assets/img/hotspotIcon/Draw_square.png"
                                                            />
                                                        </div>
                                                      </div>
                                                      <div class="clear-fix"></div>
                                                      <div class="">
                                                        @if (imgBlock.assetId) {
                                                          <div class="map-area-container">
                                                            <div
                                                              id="hotspot-creator"
                                                              appHotspotEditor
                                                              (onHotspotUpdateString)="hotSpotUpdatedString($event)"
                                                              [imgBlock]="imgBlock"
                  [imagepath]="
                    '/api/Assets/Image/' +
                    imgBlock.assetId +
                    '?height=400&ratio=' +
                    devicePixelRatio
                  "
                                                              [imageid]="imgBlock.assetId"
                                                            ></div>
                                                            <div id="map-area"></div>
                                                          </div>
                                                        }
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              }
                                              <!-- Changes for hotspot editor end -->
                                            </form>
                                          </div>
                                        }
                                        <div class="modal-footer">
                                          <button
                                            type="button"
                                            class="btn vPlaybookDefaultButton btn__btn-default"
                                            data-bs-dismiss="modal"
                                            (click)="closeEditImageModal()"
                                            >
                                            Cancel
                                          </button>
                                          <button
                                            type="button"
                                            [disabled]="form.linkUrl.errors && selectedPill === 'link'"
                                            class="btn btn__btn-default btn__orange"
                                            (click)="updateImageBlock()"
                                            >
                                            Save
                                          </button>
                                        </div>
                                      </div>

                                      <div class="modal-overlay" id="hotspotConfiguration">
                                        <div class="arrow-up"></div>
                                        <div class="modal-container medium">
                                          <div class="modal-header">
                                            Button Settings
                                            <i id="close" class="material-icons">close</i>
                                          </div>
                                          <form name="hotspotForm">
                                            <div class="modal-body" id="modal-body">
                                              <!--Header Tabs-->
                                              <ul class="nav nav-pills list-tabs playbook-tabs">
                                                <li>
                                                  <a id="tab_onclick" data-bs-toggle="pill" data-bs-target="#onClick"
                                                    >On Click</a
                                                    >
                                                  </li>
                                                  <li>
                                                    <a id="tab_hover" data-bs-toggle="pill" data-bs-target="#onHover"
                                                      >On Hover</a
                                                      >
                                                    </li>
                                                  </ul>
                                                  <hr style="margin-top: 3px; border-color: #428bca" />

                                                  <!--Content Part-->

                                                  <div class="tab-content">
                                                    <div id="onClick" class="tab-pane active">
                                                      <!--On Click content part-->
                                                      <div class="row">
                                                        <div class="col-sm-3">
                                                          <label class="radio-inline control-label">
                                                            <input
                                                              class="hotspotradiobtn"
                                                              id="hotform_rad_gotourl"
                                                              type="radio"
                                                              />Go To URL:
                                                            </label>
                                                          </div>
                                                          <div class="col-sm-9">
                                                            <input
                                                              class="uneditable-input"
                                                              id="data_id"
                                                              type="hidden"
                                                              disabled="disabled"
                                                              />
                                                            <input
                                                              class="uneditable-input"
                                                              id="data_content"
                                                              type="hidden"
                                                              disabled="disabled"
                                                              />
                                                            <input
                                                              class="uneditable-input"
                                                              id="data_content_redirect_hover"
                                                              type="hidden"
                                                              disabled="disabled"
                                                              />
                                                            <input
                                                              class="uneditable-input"
                                                              id="trigger_text"
                                                              type="hidden"
                                                              disabled="disabled"
                                                              />
                                                            <input
                                                              id="hotform_txt_gotourl"
                                                              autocomplete="off"
                                                              type="url"
                                                              class="form-control"
                                                              name="urlname"
                                                              />
                                                            <span id="invalidMessageSpan" style="color: red">
                                                              Please enter valid URL (i.e. https://google.com)
                                                            </span>
                                                          </div>
                                                        </div>
                                                        <div class="row form-group">
                                                          <div class="offset-sm-3 col-sm-9">
                                                            <label class="radio-inline me-3 control-label">
                                                              <input
                                                                type="radio"
                                                                id="new_window"
                                                                name="redirectType"
                                                                value="newwindow"
                                                                />
                                                              New Window
                                                            </label>
                                                            <label class="radio-inline control-label">
                                                              <input
                                                                type="radio"
                                                                id="same_window"
                                                                name="redirectType"
                                                                value="samewindow"
                                                                />
                                                              Same Window
                                                            </label>
                                                          </div>
                                                        </div>
                                                        <div class="row">
                                                          <div class="col-sm-3">
                                                            <label class="radio-inline control-label">
                                                              <input
                                                                class="hotspotradiobtn"
                                                                id="hotform_rad_disptext"
                                                                type="radio"
                                                                value="displayText"
                                                                />Display Text:
                                                              </label>
                                                            </div>
                                                            <div class="col-sm-9">
                                                              <textarea
                                                                id="hotform_ck_onclick_disptext"
                                                                class="editor editable"
                                                              ></textarea>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div id="onHover" class="tab-pane form-group">
                                                          <div class="row">
                                                            <label class="col-sm-3 control-label">Display Text:</label>
                                                            <div class="col-sm-9">
                                                              <textarea
                                                                id="hotform_ck_hover_disptext"
                                                                class="editor editable"
                                                              ></textarea>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="modal-footer">
                                                      <button
                                                        class="btn vPlaybookDefaultButton btn__btn-default"
                                                        id="deleteHotspotId"
                                                        >
                                                      Delete
                                                    </button>
                                                    <button
                                                      id="Hotspotcancel"
                                                      class="btn vPlaybookDefaultButton btn__btn-default"
                                                      type="button"
                                                      >
                                                      Cancel
                                                    </button>
                                                    <button
                                                      id="ok"
                                                      disabled
                                                      class="btn btn__btn-default btn__orange"
                                                      type="button"
                                                      >
                                                      Save
                                                    </button>
                                                  </div>
                                                </form>
                                              </div>
                                            </div>
